import Cookies from 'js-cookie';
import React from 'react';
import Main from './Main';
import Auth from './Auth';
import Video from './Video';
// import Info from './Info';
// import Testimonials from './Testimonials';

// const testimonials = require('./Testimonials/testimonials.json');
const enigma = require('enigma.js');
const schema = require('enigma.js/schemas/12.20.0.json');
const SenseUtilities = require('enigma.js/sense-utilities');

const url = SenseUtilities.buildUrl({
  host: 'calculators.qlik.com',
  prefix: 'sso',
});
const session = enigma.create({ schema, url });

export default class App extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      auth: null,
      loginUri: null,
      logoutUri: null,
      qGlobal: null,
      permission: null,
    };
  }

  componentWillMount() {
    console.log('component mounted');
    session.on('notification:OnAuthenticationInformation', (authInfo) => {
      console.log('onAuthenticationInformation');
      const jwt = Cookies.get('calculators');
      if (authInfo.mustAuthenticate) {
        if (jwt) {
          (async () => {
            await fetch('https://calculators.qlik.com/sso/resources/img/core/NR_NoiseDark.png', {
              method: 'GET',
              headers: {
                Authorization: `Bearer ${jwt}`,
              },
              credentials: 'include',
            });
            location.reload();
          })();
        } else {
          this.setState({ auth: false, loginUri: 'https://qdt.qlik.com/api/calculators/auth/saml/login' });
        }
      } else {
        this.setState({ auth: true, permission: true });
      }
    });

    session.open().then((global) => {
      this.setState({ qGlobal: global });
    });
  }

  render() {
    return (
      <div>
        <div className={`${this.state.auth !== null ? 'hidden' : null} d-flex justify-content-center align-items-center bg-primary text-light fullscreen`}>
          Loading
        </div>
        <div className={this.state.auth === null ? 'hidden' : null}>
          {this.state.auth ? <Main permission={this.state.permission} qGlobal={this.state.qGlobal} /> : <Auth loginUri={this.state.loginUri} />}
          <div className="container text-center"><strong>Questions?</strong> Please contact <strong>Qlik Customer Strategy & Value Engineering Team</strong> at <a href="mailto:CSVTeam@qlik.com">CSVTeam@qlik.com</a></div>
          <Video />
          {/* <Info />
          <Testimonials testimonials={testimonials} /> */}
          <p className="mb-0 mt-5" style={{ fontSize: '0.9rem' }}><em>This ROI Calculator provides ROI analysis based on standard methodology but should be regarded only as guidance and is not providing any guarantee of performance.</em></p>
          <footer className="mt-1 py-5 bg-gray300 text-center">
            <p className="text-dark mb-0">&copy; 1993-2017 QlikTech International AB, All Rights Reserved</p>
          </footer>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/App.js